import { useEffect, useState } from 'react';

import { Loader } from 'components/UI/loader/loader';
import {
  FC_STALL_MESSAGE_PREFIX,
  FcStallProgress,
  formatFcStallElapsed,
} from 'components/app/finalcuts/_helpers/fc-stall-progress.helper';

import styles from './_finalcuts-list.module.scss';

interface Props {
  stallProgress?: FcStallProgress;
}

export const FcStallProgressMessage = ({ stallProgress }: Props) => {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!stallProgress) {
      setMessage(null);
      return;
    }

    if (!stallProgress.showElapsed) {
      setMessage(FC_STALL_MESSAGE_PREFIX);
      return;
    }

    const stepStartedAt = stallProgress.stepStartedAt!;
    const update = () => setMessage(formatFcStallElapsed(stepStartedAt));

    update();
    const intervalId = window.setInterval(update, 1000);
    return () => window.clearInterval(intervalId);
  }, [stallProgress]);

  if (!message) return null;

  return (
    <div className={styles.FcList__stallProgress}>
      <Loader className={styles.FcList__stallSpinner} />
      <p className={styles.FcList__stallMessage}>{message}</p>
    </div>
  );
};
